export default __webpack_public_path__ + "static/media/bg1.57415d9c.jpg";